<div khA11yDialog>
<button khA11yActionButton class="kh-modal-close-button close-modal-icon" (click)="closeModal()" [khA11yLabel]="'A11Y_LABEL.CLOSE' | translate">
    <fa-icon khA11yHidden [icon]="['fas','times']"></fa-icon>
</button>

<div class="cancel-subscription-modal-container">
    <div khA11yLabelSource class="kh-heading-sm mb-kh-2 heading">
        {{ 'CANCEL_SUBSCRIPTION_MODAL.CANCEL_SUBSCRIPTION' | translate }}
    </div>
    <div class="body-md center my-kh-2">
        {{ 'CANCEL_SUBSCRIPTION_MODAL.ARE_YOU_SURE_YOU_WANT' | translate }}
    </div>
    <div class="buttons-container">
        <button class="kh-secondary-button kh-title-text mb-kh-2" (click)="onCancelSubscription()">{{ 'CANCEL_SUBSCRIPTION_MODAL.CANCEL_SUBSCRIPTION' | translate }}</button>
        <button class="kh-tertiary-button kh-title-text" (click)="closeModal()">{{ 'CANCEL_SUBSCRIPTION_MODAL.KEEP_PLAN' | translate }}</button>
    </div>
</div>
</div>